{
  "helpMessage": "<p>Afai e iai se fa‘afitauli, fa‘amolemole vala‘au mai i le <a><strong>{{phone}}</strong></a> (ona oomi lea o le <strong>Filifiliga 2</strong>).</p>",
  "noCode": "E te le‘i maua le numera?",
  "remainingTime": "{{time}} o lo‘o totoe",
  "sendCode": "Lafo se numera fou",
  "text": "<p>Ua matou lafoina se numera e 4 numera i lau numera telefoni: <strong><PhonePlaceholder /></strong></p>\n<p>O le numera e aoga mo le {{validityMinutes}} minute.</p>\n<p>Fa‘amolemole ulufale le numera i lalo e fa‘aauau ai.</p>",
  "title": "Ulufale lau numera"
}
